import Vue, { VNode } from 'vue'
import { Component, Provide } from 'vue-property-decorator'
import SysHeader from '@/components/header/view'
import { Tabs, TabPane } from 'element-ui'
import { apps, KitItem } from './model'
import AppCard from '@/components/app-item/view'

import $style from './index.module.scss'
import { AppItem } from '@/model/definitions'

@Component({
  components: {
    AppCard,
    SysHeader,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  }
})
export default class extends Vue {
  @Provide() private appList: KitItem[] = apps
  @Provide() private activeTab = 'pro'

  private appClick(url: string): void {
    url && window.open(url)
  }

  render(): VNode {
    return <div class={$style.guide_viewport}>
      <sys-header></sys-header>
      <el-tabs type="border-card" v-model={ this.activeTab }>
        <el-tab-pane label="Test环境" name="test">
          {
            this.appList.map((app: KitItem, index: number) => {
              const d: AppItem = {
                id: app.id,
                order: index,
                avatarUrl: app.avatarUrl,
                appName: app.appName,
                link: app.env.test ? app.env.test.link : '',
                user: app.env.test ? app.env.test.user : '',
                pwd: app.env.test ? app.env.test.pwd : ''
              }
              const tip: string = d.user && d.pwd ? `用户名: ${d.user}, 密码: ${d.pwd}` : ''
              return d.link ? <app-card props={{ model: d }} canFav={false} nameTip={tip} onClick={this.appClick.bind(this, d.link)}></app-card> : null
            })
          }
        </el-tab-pane>
        <el-tab-pane label="UAT环境" name="uat">
          {
            this.appList.map((app: KitItem, index: number) => {
              const d: AppItem = {
                id: app.id,
                order: index,
                avatarUrl: app.avatarUrl,
                appName: app.appName,
                link: app.env.uat ? app.env.uat.link : '',
                user: app.env.uat ? app.env.uat.user : '',
                pwd: app.env.uat ? app.env.uat.pwd : ''
              }
              const tip: string = d.user && d.pwd ? `用户名: ${d.user}, 密码: ${d.pwd}` : ''
              return d.link ? <app-card props={{ model: d }} canFav={false} nameTip={tip} onClick={this.appClick.bind(this, d.link)}></app-card> : null
            })
          }
        </el-tab-pane>
        <el-tab-pane label="生产环境" name="pro">
          {
            this.appList.map((app: KitItem, index: number) => {
              const d: AppItem = {
                id: app.id,
                order: index,
                avatarUrl: app.avatarUrl,
                appName: app.appName,
                link: app.env.pro ? app.env.pro.link : '',
                user: app.env.pro ? app.env.pro.user : '',
                pwd: app.env.pro ? app.env.pro.pwd : ''
              }
              const tip: string = d.user && d.pwd ? `用户名: ${d.user}, 密码: ${d.pwd}` : ''
              return d.link ? <app-card props={{ model: d }} canFav={false} nameTip={tip} onClick={this.appClick.bind(this, d.link)}></app-card> : null
            })
          }
        </el-tab-pane>
      </el-tabs>
    </div>
  }
}
